<ion-app *ngIf="hydrated$ | async">
  <qld-commercial-side-menu></qld-commercial-side-menu>
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
